module.exports = __webpack_public_path__ + "static/shakehands-bdc625736567fcaeaa8e705c68a9f794.png";